export default __webpack_public_path__ + "static/quote-5-b63312e6c4c85506c424bfc5cd32a257.mp3";